import { Link } from "react-router-dom";
const AppName = ({ CSSStyles, homeCSS }) => {
  return (
    <h1 className={`font-bold text-purple-100 ${CSSStyles}`}>
      {" "}
      <Link to="/">
        Digital
        <span className={!homeCSS ? "text-purple-400" : "text-gray-900"}>
          Marketsquare
        </span>
      </Link>
    </h1>
  );
};

export default AppName;
